<template>
  <div id="chunk-container">
    <div
      v-for="(intro, index) in this.intros[episode_index].intro_text"
      :key="intro"
      @click="
        $store.commit('updateChunkPlayback', '0' + (index + 1) + '-Intro.mp3')
      "
    >
      <IntroCard
        :text="intro"
        :intro_id="'0' + (index + 1) + '-Intro.mp3'"
        class="introduction-chunk"
      />
    </div>

    <div @click="$store.commit('updateChunkPlayback', '04-Intro.mp3')">
      <IntroCard
        id="trigger-warning"
        :intro_id="'04-Intro.mp3'"
        v-if="this.intros[episode_index].trigger_warning != ''"
        :text="this.intros[episode_index].trigger_warning"
        class="introduction-chunk"
      />
    </div>

    <div
      v-for="(chunk, index) in this.chunks[episode_index]"
      :key="chunk.chunk_id"
    >
      <div
        class="speaker"
        v-if="
          index == 0 ||
          chunk.speaker != chunks[episode_index][index - 1].speaker
        "
        @click="
          changeParticipantsState();
          $store.commit('updateSpeakerBio', chunk.speaker);
        "
      >
        <div
          class="speaker-name"
          :style="{ color: speaker_colors[chunk.speaker][0] }"
        >
          {{ chunk.speaker }}
        </div>
        <div class="org-name">
          {{ speaker_short_description[chunk.speaker] }}
        </div>
        <div class="speaker-avatar">
          <img
            class="speaker-avatar-image"
            :src="require('../assets/speaker-avatar/' + chunk.speaker + '.jpg')"
            alt="speaker portrait"
            :style="{ borderColor: speaker_colors[chunk.speaker][0] }"
          />
        </div>
      </div>

      <div
        :id="chunk.source_file"
        class="chunk"
        :class="{ shadow: chunk_alternative && chunk.chunk_id }"
        @click="
          chunk_id = chunk.chunk_id;
          $store.commit('updateChunkPlayback', chunk.source_file);
          changeEploreRelatedContent();
        "
      >
        <div
          class="left-marker"
          :style="{ backgroundColor: speaker_colors[chunk.speaker][0] }"
        />

        <div :id="chunk.source_file + '_text'" class="chunk-text">
          {{ removeQuotationMarks(chunk.text) }}
        </div>

        <TransitionExpand>
          <div
            v-if="
              chunkPlayback == chunk.source_file &&
              exploreRelatedContent == true
            "
            class="explore-related-content-wrapper"
          >
            <div class="explore-related-content-padding">
              <div
                class="explore-related-content"
                @click.stop="changeExplorationState()"
              >
                Explore related content
              </div>
            </div>
          </div>
        </TransitionExpand>
      </div>
    </div>
    <div
      id="outro-chunk"
      @click="$store.commit('updateChunkPlayback', '9999-Outro.mp3')"
    >
      <IntroCard
        v-if="episode_index != 1 && episode_index != 2 && episode_index != 0"
        :text="'You just heard an episode of Framing Human Rights. Thank you for joining us today. If you enjoyed our podcast, register for our newsletter and stay up to date with ECCHR’s work. You can also support us by donating online at ecchr.eu'"
        :intro_id="'9999-Outro.mp3'"
        class="introduction-chunk"
      />

      <IntroCard
        v-if="episode_index == 2 || episode_index == 0"
        :text="'You just heard an episode of Framing Human Rights. Thank you for joining us today. For additional materials linked to the work and projects discussed in this episode visit explore.ecchr.eu to launch our interactive experience. If you enjoyed our podcast, register for our newsletter and stay up to date with ECCHR’s work. You can also support us by donating online at ecchr.eu'"
        :intro_id="'9999-Outro.mp3'"
        class="introduction-chunk"
      />

      <IntroCard
        v-if="episode_index == 1"
        :text="'Sie hörten eine Folge von Framing Human Rights. Weitere Materialien zu den Werken und Projekten aus dieser Folge finden Sie auf unserer Interaktiven Plattform explore.ecchr.eu. Wenn Ihnen unser Podcast gefallen hat, registrieren Sie sich gern für unseren Newsletter. Sie können uns auch unter ecchr.eu mit einer Spende unterstützen.'"
        :intro_id="'9999-Outro.mp3'"
        class="introduction-chunk"
      />
    </div>
  </div>
</template>

<script>
import TransitionExpand from "../components/TransitionExpand.vue";

import eyal from "../data/episode_transcripts/eyal.json";
import benedicte from "../data/episode_transcripts/benedicte.json";
import priya from "../data/episode_transcripts/priya.json";
import mark from "../data/episode_transcripts/mark.json";
import fred from "../data/episode_transcripts/fred.json";
import rabih from "../data/episode_transcripts/rabih.json";
import christina from "../data/episode_transcripts/christina.json";
import ixmucane from "../data/episode_transcripts/ixmucane.json";
import claudia from "../data/episode_transcripts/claudia.json";

import IntroCard from "./IntroCard.vue";
import { mapState } from "vuex";
import config from "../data/ecchr_config.json";

export default {
  name: "ChunkCards",
  components: {
    IntroCard,
    TransitionExpand,
  },
  data() {
    return {
      chunks: [
        eyal["chunk_sequence"],
        benedicte["chunk_sequence"],
        priya["chunk_sequence"],
        fred["chunk_sequence"],
        rabih["chunk_sequence"],
        christina["chunk_sequence"],
        claudia["chunk_sequence"],
        mark["chunk_sequence"],
        ixmucane["chunk_sequence"],
      ],
      speaker_short_description: config["speaker_short_description"],
      speaker_colors: config["speaker_colors"],
      intros: [
        eyal,
        benedicte,
        priya,
        fred,
        rabih,
        christina,
        claudia,
        mark,
        ixmucane,
      ],
      entityIsActive: false,
      chunk_id: 0,
      show: false,
      chunk_alternative: false,
      driver: Object,
      response_similarity: Array(),
      response_images: Array(),
    };
  },
  computed: {
    ...mapState([
      "episode_id",
      "episode_index",
      "chunkPlayback",
      "exploreRelatedContent",
    ]),
    participantsVisible() {
      return this.$store.state.participantsVisible;
    },
    explorationVisible() {
      return this.$store.state.explorationVisible;
    },
  },
  methods: {
    changeParticipantsState() {
      this.$store.commit("toggleParticipants");
    },
    changeExplorationState() {
      this.$store.commit("toggleExploration");
    },
    changeEploreRelatedContent() {
      this.$store.commit("toggleExploreRelatedContent");
    },
    removeQuotationMarks(text) {
      return text.replace(/"/g, "");
    },
  },
};
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300&display=swap");

.introduction-chunk {
  margin: 0px 30px 5px 50px;
}

.introduction-chunk:hover {
  cursor: pointer;
}

.speaker {
  grid-gap: 2px;
  background-color: rgba(58, 58, 60, 1);
  border-radius: 8px;
  display: grid;
  grid-template-columns: 80% 20%;
  margin-top: 20px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 15px;
  padding: 15px 25px 15px 25px;
}

.speaker:hover {
  cursor: pointer;
}

.speaker-name {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;
  font-weight: 700;
  font-size: 16px;
  align-self: flex-end;
}

.org-name {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 2;
  grid-row-end: 3;
  font-weight: 300;
  font-size: 16px;
  margin-right: 15px;
}

.speaker-avatar {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
}

.speaker-avatar-image {
  border-radius: 50%;
  border-width: 3px;
  border-style: solid;
}

.speaker-avatar > .speaker-avatar-image {
  align-items: center;
  max-width: 100%;
  max-height: 100%;
}

.chunk {
  display: grid;
  grid-template-columns: 15px auto;
  /* grid-template-rows: auto 60px; */
  background-color: rgba(30, 30, 30, 1);
  border-radius: 8px;
  padding: 15px 22px 15px 22px;
  margin: 0px 30px 5px 50px;
  transition: 0.3s ease-in-out;
}

.chunk:hover {
  cursor: pointer;
}

.shadow {
  -webkit-box-shadow: 10px 9px 5px -4px rgb(66, 66, 66);
  -moz-box-shadow: 10px 9px 5px -4px rgba(179, 179, 179, 1);
  box-shadow: 8px 6px 1px 0px rgba(117, 117, 117, 0.5);
}

.chunk-text {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  grid-column-start: 2;
  grid-column-end: 3;
  font-size: 16px;
  line-height: 21px;
  color: rgba(100, 100, 100, 1);
  transition: 0.3s ease-in-out;
}

.left-marker {
  grid-column-start: 1;
  grid-column-end: 2;
  justify-items: start;
  width: 3px;
  height: 100%;
  border-radius: 1.5px;
  z-index: 0;
  opacity: 0.3;
  transition: 0.3s ease-in-out;
}

.explore-related-content {
  background-color: rgba(30, 30, 30, 1);
  color: rgba(160, 160, 160, 1);
  width: fit-content;
  margin-bottom: 0px;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
}

.explore-related-content-wrapper {
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 2;
  grid-row-end: 3;
}

.explore-related-content-padding {
  padding-top: 15px;
}

#chunk-container {
  padding-bottom: 100px;
}

#outro-chunk {
  padding-top: 30px;
}
</style>